import {SlackPayload} from "helpers/SlackNotifier/types";
import axios from "axios";

export async function notifySlack(message: string): Promise<void> {
	const webhookUrl = process.env.REACT_APP_SLACK_WEBHOOK_URL;

	if (!webhookUrl) {
		console.warn("Slack webhook URL is not defined");

		return;
	}

	const payload: SlackPayload = {text: message};

	try {
		await axios({
			method: "POST",
			url: webhookUrl,
			headers: {"Content-Type": "application/x-www-form-urlencoded"},
			data: JSON.stringify(payload),
		});
	} catch (err) {
		console.error("Failed to send Slack notification", err);
	}
}
